<script lang="ts">
	import { page } from '$app/stores';
	import HeaderLink from './HeaderLink.svelte';
	import { slide } from 'svelte/transition';
	import domain from '$lib/stores/DomainStore';
	import __ from '$lib/stores/TranslationStore';
	import HeaderGroup from './HeaderGroup.svelte';
	import Cta from '../Cta.svelte';

	export let showMenu: boolean | any;
	import { invalidateAll } from '$app/navigation';
	import { supportedLanguages } from '$lib/translations/translations';
	import buildLanguagePath from '$lib/utils/buildLanguagePath';
</script>

{#if showMenu}
	<ul
		transition:slide
		class="fixed left-0 top-12 flex w-full flex-col justify-center gap-x-5 divide-y divide-light shadow-lg md:items-center md:gap-y-5 md:divide-y-0 lg:static lg:left-auto lg:top-auto lg:flex lg:w-auto lg:min-w-0 lg:shrink lg:flex-row lg:py-0 lg:shadow-none xl:gap-x-7 {$domain?.headerBackground}"
	>
		<HeaderLink on:click url="/credito-habitacao" text={$__('Crédito habitação')} />
		{#if !$page.data.int_ch}
			<HeaderLink on:click url="/credito-consolidado" text={$__('Crédito consolidado')} />
			<HeaderLink on:click url="/seguros" text={$__('Seguros')} />
			<HeaderLink
				on:click
				active={$page.url.pathname.startsWith('/artigos/')}
				url="/artigos"
				text={$__('Artigos')}
			/>
		{/if}
		<HeaderGroup
			on:click
			title={$__('Institucional')}
			items={[
				{ title: $__('Sobre nós'), path: '/sobre' },
				{ title: $__('Recrutamento'), path: '/recrutamento' },
				{ title: $__('Contacto'), path: '/contacto' }
			]}
		/>
		<HeaderGroup
			on:click
			title={$page.data.language.toUpperCase()}
			titleClass="font-semibold"
			items={supportedLanguages
				.filter((l) => l !== $page.data.language)
				.map((lang) => ({
					title: lang.toUpperCase(),
					path: null
				}))}
			let:item
		>
			<a
				href={buildLanguagePath($page.url.pathname, item.title)}
				class="block w-full py-2 text-left md:px-4"
			>
				<span>{item.title}</span>
			</a>
		</HeaderGroup>
		<li class="lg:hidden lg:min-w-0">
			<div class="px-4 py-6 md:p-0 md:pb-5">
				<Cta
					type="anchor"
					class="w-full text-xl/none leading-nav-button 3xl:text-nav-button {$domain?.buttonBackground} {$domain?.buttonColor}"
					props={{
						'data-sveltekit-preload-data': 'off',
						href: '/simuladores'
					}}
					on:click
				>
					{$__('Simular crédito')}
				</Cta>
			</div>
		</li>
	</ul>
{/if}
